export default "__VITE_ASSET__576cd812__"